<template>
  <div class="db-wrapper-checkable">
    <input
      :id="uid"
      v-model="model"
      type="checkbox"
      class="db-checkbox"
      v-bind="inputAttrs"
    />
    <label
      :for="uid"
      class="db-label"
    >
      <slot />
    </label>
  </div>
</template>

<script setup lang="ts">
import { v4 as uuidv4 } from 'uuid'
import { computed } from 'vue'
import type { CheckboxAttrs } from '@/types/components/forms'

const props = defineProps<{
  /** binds /w `v-model` directive */
  modelValue: CheckboxAttrs['checked']
  /** InputHTMLAttributes /w `name` & `value` required and `id` omitted */
  inputAttrs?: CheckboxAttrs
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', modelValue: CheckboxAttrs['checked']): void
}>()

/** Unique id for label / input binding */
const uid = uuidv4()

/** Computed to handle v-model directive */
const model = computed({
  get() {
    return props.modelValue
  },
  set(value: CheckboxAttrs['checked']) {
    emit('update:modelValue', value)
  },
})
</script>

<style>
@import '@/assets/styles/commons/forms/_inputs-checkable.css';
@import '@/assets/styles/components/forms/_checkbox.css';
</style>
